import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { AppMonitoringService } from '../services/app-monitoring.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private readonly injector: Injector) {}

  handleError(error: Error) {
    const appMonitoringService = this.injector.get(AppMonitoringService);
    appMonitoringService.logException(error);

    // added to maintain existing error triage
    console.error(error);
  }
}
